import { css } from 'styled-components'

/** Lato da cui il bersaglio cresce: quello dove c'e' spazio libero. */
export type Verso = 'alto' | 'basso'

/**
 * Porta l'area cliccabile di un link `inline` ai 24 px richiesti da WCAG 2.5.8
 * (ticket 42X4S) **senza spostare niente a schermo**.
 *
 * Come funziona: il padding verticale di un elemento `inline` non entra nel
 * calcolo dell'altezza della riga, quindi allarga il box (e quindi l'area
 * cliccabile) lasciando il layout intatto. Il testo di questi link e' alto
 * 13-15 px: 10 px di padding da un solo lato portano il box a 23-25 px.
 *
 * Perche' da UN SOLO lato: nel sito questi link stanno su righe consecutive
 * separate da `<br/>` o da `<li>`, a **7 px** l'uno dall'altro. Con il padding
 * su entrambi i lati le due aree cliccabili si sovrapporrebbero di 3 px, cioe'
 * si creerebbe esattamente il rischio di attivare il bersaglio sbagliato che
 * 2.5.8 vuole prevenire: passerebbe il validatore peggiorando la sostanza.
 * Ogni link cresce quindi verso il lato libero — il primo verso l'alto,
 * l'ultimo verso il basso — e i 7 px fra i due restano intatti.
 *
 * **Solo su elementi `inline`.** Su `block`, `inline-block` o `flex` il padding
 * sposta il layout: verificato su un CTA `display: flex` di `/la-nostra-rete`,
 * dove muoveva 1847 pixel.
 *
 * Misure in evidenze della remediation a11y, fuori dal repo, sessione 2026-08-31.
 */
export const areaCliccabile24 = (verso: Verso) => css`
  ${verso === 'alto' ? 'padding-top' : 'padding-bottom'}: 10px;
`
